import React, { forwardRef, useRef, createElement } from "react";
import styled from "styled-components";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import { FeatureFlags, getFeatureFlag } from "../../utilities/featureFlags";
import { parseCss } from "../../utilities/parseCss";
import classNames from "classnames";
import parse, { domToReact, attributesToProps } from "html-react-parser";
import { useScript } from "../Hooks/useScript";
import Picture from "../Picture";


export interface IMarkupProps extends IEditableProps, IStyledProps {
    html: string;
    cssStyle: string;
    javascript: string;
    runScript: boolean;
    widgetType;
}

function parseHTML(html: string, enableWebp: boolean) {
    if (!html) return null;
    try {
        return parse(html, {
            replace: domNode => {
                if (domNode.attribs ) {
                    if (domNode.attribs && domNode.attribs.onclick) {
                        const { onclick, ...attrs } = domNode.attribs;
                        const props = {
                            ...attributesToProps(attrs),
                            onClick: () => {
                                try {
                                    new Function(onclick)();
                                } catch(error) {
                                    console.error('Markup parseHtml()', error.message);
                                }
                            }
                        }
    
                        const elChildren = domNode.children && domNode.children.length ? domToReact(domNode.children) : null;
    
                        return createElement(domNode.name, props, elChildren);
                    }
                    if (domNode.attribs && domNode.name === 'img' && domNode?.parent?.name !== 'picture' && enableWebp) {
                        const { ['data-test-id']: dataTestId, ...attrs} = domNode.attribs;
                        const loading = attrs.loading || 'lazy';
                        return <Picture {...attributesToProps(attrs)} loading={loading} dataTestId={dataTestId} />
                    }
                }
            }
        });
    } catch (e) {
        console.error('Markup widget error:', e);
        return <div className="error-message">Error: Invalid html in Markup widget: {e.message}</div>;
    }
}

const Markup = styled(forwardRef((props: IMarkupProps, ref: any) => {
    const innerRef = useRef(ref);
    const enableWebp = getFeatureFlag(FeatureFlags.PREFER_WEBP_IMAGES);
    const enableWebpCss = getFeatureFlag(FeatureFlags.PREFER_WEBP_IMAGES_CSS);

    useScript(props.javascript, props.runScript);
    return (
        <>
            {props.cssStyle && (
                <style>
                    {enableWebpCss ? 
                        parseCss(props.cssStyle)
                    :
                        props.cssStyle.replace(/\n/g, '').replace(/\s\s+/g, ' ')
                    }         
                </style>
            )}
            <div data-id={props.cmsId} ref={innerRef} className={classNames(props.className, props.editorClassObj, 'custom-content', 'markup-container')}>
                {parseHTML(props.html, enableWebp)}
            </div>
        </>
    );
}))`
&:empty {
    width: 100%;
    min-height: 300px;
    background: #fafafa;
}
.error-message {
    padding: 10px;
    border: 1px solid #cc0000;
    color: #cc0000;
}
`;

export default Markup;
